interface IReportNumber {
  value: number | string
  color: ReportNumberType
}
enum ReportNumberType {
  red = 'red',
  orange = 'orange',
  blue = '',
}

interface IReportTempViewProps {
  value: number
  min: number
  max: number
}
const isValidTemp = (value: number, min: number, max: number) => {
  return value >= min && value <= max
}
export const ReportTempView = ({ value, min, max }: IReportTempViewProps) => {
  return isValidTemp(value, min, max) ? (
    <span>{value?.toFixed(2).toString().replace(/[.]/g, ',')}</span>
  ) : (
    <ReportNumber
      value={value?.toFixed(2).toString().replace(/[.]/g, ',')}
      color={ReportNumberType.red}
    />
  )
}
const ReportNumber = ({
  value,
  color = ReportNumberType.blue,
}: IReportNumber) => {
  return (
    <div className={`report-number ${color}`}>
      {value.toString().replace(/[.]/g, ',')}
    </div>
  )
}
